import type { FaireProductEntity } from "../../entity_types/product";

export const p_kju2ykvsdz: FaireProductEntity = {
  token: "p_kju2ykvsdz",
  type: "product",
  name: "Cozy Thick Plush Hemp-Knit Socks For Fall & Winter_CWMS0881",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/67edfa4231b9d252d7ac10e9b857fdd4a1fe6ff550fc27d8eec12c824c27f39f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a0949371b14d1f10bac14d55eb4a53679b8fd3a8a495748497d72a8bfe40362.jpeg",
    "https://cdn.faire.com/fastly/16a5c04aedeab5490285fd3815a803049a672957c9fb9620813a03679d37da81.jpeg",
    "https://cdn.faire.com/fastly/cd79607dd2cbc4cea2408b7c44b1a94b6ec1e78a535ea20d4aa1b46e2c745e01.jpeg",
    "https://cdn.faire.com/fastly/f8063904d3c0ad03103bcdf4a0b7748826cd2598b1e4c71ac238be2e522cd399.jpeg",
    "https://cdn.faire.com/fastly/801c0ec01d23bc930f83d3bc1f1f4c6892994a4b4fc5e911d057e452f9e9b892.jpeg",
    "https://cdn.faire.com/fastly/0292c427ff1fb23fea316194802de8faf74b358efd6d935bf0473f580237375c.jpeg",
    "https://cdn.faire.com/fastly/42dced2e5bc677c3765dfac57d133a695c1d9b425d7251e0933eafd12fd9405b.jpeg",
    "https://cdn.faire.com/fastly/10e40cb1ec24e3e20e6775d57c6f298d158ad2a520e7c1d1344442796d16a133.jpeg",
    "https://cdn.faire.com/fastly/2e386631daa9175cb5a6b5589064e4256dfc3db0d045a54fc29176dc00315180.jpeg",
    "https://cdn.faire.com/fastly/db90745bd5f199c58a2e6e95e5751e3762a39f1a8b8e2210d808a3783c2f7cea.jpeg",
    "https://cdn.faire.com/fastly/90e44760987a6f6d0a7b74518cd53debd0f888b506d81991926eb7572e0f841b.jpeg",
    "https://cdn.faire.com/fastly/3d60c920fdb7a936b7fec74ab63435fdf81f6667518d1ec7b32d6f6e7f70b53f.jpeg",
    "https://cdn.faire.com/fastly/0f65aa8f3bd53a17e725e17f718deca66e99b5ea0a1e34baf2e5396db027d676.jpeg",
    "https://cdn.faire.com/fastly/2356e287580ff42b4c929be3ead9539973018ac58155eceb1f5f617e535b43f2.jpeg",
  ],
  priceDollars: 4.21,
  description:
    "• Fabric Name: Towel/Terry Fabric\n• Function: Sweat Absorption\n• Main Material Composition: 90~95% Polyester Fiber (Polyester)\n• Mid-Calf Socks\n• Season: Winter\n\n⭐⭐☆☆☆ Basic quality: simple and functional for occasional use.\n\n🧦 𝐃𝐮𝐫𝐚𝐛𝐢𝐥𝐢𝐭𝐲:\n\n• 🌀 Daily wear + machine wash + indoor walking: 1–2 months\n• 🧼 Weekly wear + hand wash + worn with slippers: 3–6 months\n\n𝐓𝐲𝐩𝐞𝐬 𝐎𝐟 𝐏𝐫𝐨𝐝𝐮𝐜𝐭𝐬 𝐓𝐡𝐚𝐭 𝐖𝐢𝐥𝐥 𝐁𝐞 𝐎𝐧 𝐓𝐡𝐞 𝐒𝐡𝐞𝐥𝐯𝐞𝐬 𝐃𝐮𝐫𝐢𝐧𝐠 𝐓𝐡𝐢𝐬 𝐏𝐞𝐫𝐢𝐨𝐝:\nWinter socks, Warm socks, Thick socks, Wool socks, Fleece lined socks, Thermal socks, Cozy socks, Fluffy socks, Sherpa socks, Knit socks, Cable knit socks, Crew winter socks, Ankle winter socks, Over the calf warm socks, Slipper socks, Non-slip winter socks, Winter socks for women, Winter socks for men, Winter socks for kids, Christmas socks, Holiday fuzzy socks, Cute winter socks, Outdoor thermal socks, Ski socks, Hiking winter socks, Winter boot socks, Home lounge socks, Vintage knit socks, Patterned warm socks, Soft thick socks, Cold weather socks.",
  tags: [],
  msrpDollars: 8.42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:35.384Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
